import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqService } from '../services/constructionBoq.service';
import type { ConstructionBoq } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useConstructionBoqDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-boqs', 'detail', id],
    queryFn: () => ConstructionBoqService.getBoqDetail(id!),
    enabled: !!id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<ConstructionBoq>) => ConstructionBoqService.updateBoq(id!, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs'] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'detail', id] });
      toast.success('Cập nhật BOQ thành công');
    },
  });

  return {
    boq: query.data,
    isLoading: query.isLoading,
    updateBoq: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
